module.exports = __webpack_public_path__ + "static/media/pic8.85d672e3.jpg";